module.exports = __webpack_public_path__ + "img/avatar.4dd600c6.svg";